// extracted by mini-css-extract-plugin
export default {"custom":"customScene_custom__xT7v8","custom_p":"customScene_custom_p__ae-nM"};